import React, { useState } from 'react';
import { brandName, siteContent } from '../content/siteContent';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="header">
      <div className="container">
        <a href="#hero" className="brand" aria-label={siteContent.header.brandLabel}>
          {brandName}
        </a>
        <button
          className="menu-toggle"
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
          aria-controls="primary-nav"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="burger" aria-hidden="true"></span>
        </button>
        <nav id="primary-nav" aria-label="Primary" className={isOpen ? 'open' : ''}>
          <ul>
            <li><a href="#hero" onClick={closeMenu}>Home</a></li>
            <li><a href="#social-proof" onClick={closeMenu}>Reviews</a></li>
            <li><a href="#services" onClick={closeMenu}>Services</a></li>
            <li><a href="#about" onClick={closeMenu}>About</a></li>
            <li><a href="#staff" onClick={closeMenu}>Staff</a></li>
            <li><a href="#pricing" onClick={closeMenu}>Pricing</a></li>
            <li><a href="#contact" onClick={closeMenu}>Contact</a></li>
          </ul>
        </nav>
        <a href="#contact" className="header-cta btn btn--primary" onClick={closeMenu}>
          {siteContent.header.ctaLabel}
        </a>
      </div>
    </header>
  );
};

export default Header;
